module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "textcontainer"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "5%"
    }
  }, [_c('research'), _vm._v(" "), _c('p'), _c('h4', [_vm._v("Legend:")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p'), _vm._v(" "), _c('h3', [_vm._v("Books")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h3', [_vm._v("Articles")]), _vm._v(" "), _c('div', {
    staticClass: "nomobile"
  }, [_c('table', [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.articles), function(art) {
    return _c("articlerow", {
      key: art.title,
      tag: "tr",
      attrs: {
        "art": art
      }
    })
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "mobileonly"
  }, _vm._l((_vm.articles), function(art) {
    return _c('mobilearticlerow', {
      key: art.title,
      attrs: {
        "art": art
      }
    })
  })), _vm._v(" "), _c('h3', [_vm._v("Chapters in Edited Volumes")]), _vm._v(" "), _c('div', {
    staticClass: "nomobile"
  }, [_c('table', [_vm._m(5), _vm._v(" "), _c('tbody', _vm._l((_vm.chapters), function(chap) {
    return _c("chapterrow", {
      key: chap.title,
      tag: "tr",
      attrs: {
        "art": chap
      }
    })
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "mobileonly"
  }, _vm._l((_vm.chapters), function(chap) {
    return _c('mobilechapterrow', {
      key: chap.title,
      attrs: {
        "art": chap
      }
    })
  })), _vm._v(" "), _c('h3', [_vm._v("Book Reviews")]), _vm._v(" "), _c('div', {
    staticClass: "nomobile"
  }, [_c('table', [_vm._m(6), _vm._v(" "), _c('tbody', _vm._l((_vm.bookReviews), function(rev) {
    return _c("articlerow", {
      key: rev.title,
      tag: "tr",
      attrs: {
        "art": rev
      }
    })
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "mobileonly"
  }, _vm._l((_vm.bookReviews), function(rev) {
    return _c('mobilearticlerow', {
      key: rev.title,
      attrs: {
        "art": rev
      }
    })
  })), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": _vm.bturl,
      "download": "gowder.bib"
    }
  }, [_vm._v("download bibtex")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": _vm.risurl,
      "download": "gowder.ris"
    }
  }, [_vm._v("download ris (reference manager format)")])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('p', [_vm._v("\n\n                      See cv page for additional, minor, publications.\n                      ")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "legendtable"
  }, [_c('tr', [_c('td', [_c('img', {
    staticClass: "pubsicon",
    attrs: {
      "src": require("../../assets/icons/file-text.svg")
    }
  })]), _vm._v(" "), _c('td', [_vm._v("\n        abstract\n      ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    staticClass: "pubsicon",
    attrs: {
      "src": require("../../assets/icons/external-link.svg")
    }
  })]), _vm._v(" "), _c('td', [_vm._v("\n        official/journal link\n      ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    staticClass: "pubsicon",
    attrs: {
      "src": require("../../assets/icons/cloud-download.svg")
    }
  })]), _vm._v(" "), _c('td', [_vm._v("\n        unofficial/preprint link (may not be final version)\n      ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('em', [_vm._v("The Networked Leviathan: For Democratic Platforms")]), _vm._v(", Cambridge University Press 2023. "), _c('br'), _vm._v(" For more information, to buy, or to download a free open-access PDF, go to "), _c('a', {
    attrs: {
      "href": "https://networked-leviathan.com"
    }
  }, [_vm._v("networked-leviathan.com")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('em', [_vm._v("The Rule of Law in the United States: An Unfinished Project of Black Liberation")]), _vm._v(", Hart Publishing/Bloomsbury 2021. "), _c('br'), _vm._v(" For more information, to buy, or to download a free open-access PDF, go to "), _c('a', {
    attrs: {
      "href": "https://rulelaw.us"
    }
  }, [_vm._v("rulelaw.us")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('em', [_vm._v("The Rule of Law in the Real World")]), _vm._v(", Cambridge University Press 2016. "), _c('br'), _vm._v(" For more information or to buy, go to "), _c('a', {
    attrs: {
      "href": "https://rulelaw.net"
    }
  }, [_vm._v("rulelaw.net")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Citation")]), _vm._v(" "), _c('th', [_vm._v("Year")]), _vm._v(" "), _c('th', [_vm._v("options")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Citation")]), _vm._v(" "), _c('th', [_vm._v("Year")]), _vm._v(" "), _c('th', [_vm._v("options")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Citation")]), _vm._v(" "), _c('th', [_vm._v("Year")]), _vm._v(" "), _c('th', [_vm._v("options")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n\t\t\t\tIf you use Zotero for reference management, you can also add individual publications directly to your library via "), _c('a', {
    attrs: {
      "href": "https://www.zotero.org/paulgowder"
    }
  }, [_vm._v("my Zotero profile")]), _vm._v(" (give the list a moment to load). \n\t\t\t")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6052fc91","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pubs/publications.vue
// module id = 196
// module chunks = 0